import {
  BasketballEventStatusId,
  BasketballIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  EventDurationConfig,
  GetEventStatusDuration,
  GetIncidentDuration,
  GetIncidentIdDuration,
  getLiveDuration,
} from '../../configuration'

const getIncidentIdDuration: GetIncidentIdDuration = (
  incidentId,
  numberOfPeriods,
) => {
  switch (incidentId) {
    // regular time - quarters
    case BasketballIncidentId.FirstQuarterStarted:
      return { period: 1, overtime: 0 }
    case BasketballIncidentId.BreakAfterFirstQuarter:
      return { period: 2, overtime: 0 }
    case BasketballIncidentId.SecondQuarterStarted:
      return { period: 2, overtime: 0 }
    case BasketballIncidentId.BreakAfterSecondQuarter:
      return { period: 3, overtime: 0 }
    case BasketballIncidentId.ThirdQuarterStarted:
      return { period: 3, overtime: 0 }
    case BasketballIncidentId.BreakAfterThirdQuarter:
      return { period: 4, overtime: 0 }
    case BasketballIncidentId.FourthQuarterStarted:
      return { period: 4, overtime: 0 }

    // regular time - halves
    case BasketballIncidentId.FirstHalfStarted:
      return { period: 1, overtime: 0 }
    case BasketballIncidentId.BreakAfterFirstHalf:
      return { period: 2, overtime: 0 }
    case BasketballIncidentId.SecondHalfStarted:
      return { period: 2, overtime: 0 }

    // regular time - quarters & halves
    case BasketballIncidentId.FinishedRegularTime:
      return { period: numberOfPeriods + 1, overtime: 0 } // +1 : period is finished
    case BasketballIncidentId.WaitingForOvertime:
      return { period: numberOfPeriods + 1, overtime: 0 } // +1 : period is finished

    // overtime
    case BasketballIncidentId.FirstOvertimeStarted:
      return { period: numberOfPeriods, overtime: 1 }
    case BasketballIncidentId.BreakAfterFirstOvertime:
      return { period: numberOfPeriods, overtime: 2 }
    case BasketballIncidentId.SecondOvertimeStarted:
      return { period: numberOfPeriods, overtime: 2 }
    case BasketballIncidentId.BreakAfterSecondOvertime:
      return { period: numberOfPeriods, overtime: 3 }
    case BasketballIncidentId.ThirdOvertimeStarted:
      return { period: numberOfPeriods, overtime: 3 }
    case BasketballIncidentId.BreakAfterThirdOvertime:
      return { period: numberOfPeriods, overtime: 4 }
    case BasketballIncidentId.FourthOvertimeStarted:
      return { period: numberOfPeriods, overtime: 4 }
    case BasketballIncidentId.BreakAfterFourthOvertime:
      return { period: numberOfPeriods, overtime: 5 }
    case BasketballIncidentId.FifthOvertimeStarted:
      return { period: numberOfPeriods, overtime: 5 }

    default:
      return null
  }
}

const getEventStatusDuration: GetEventStatusDuration = (
  eventStatusId,
  numberOfPeriods,
) => {
  switch (eventStatusId) {
    // regular time - quarters
    case BasketballEventStatusId.FirstQuarter:
      return { period: 1, overtime: 0 }
    case BasketballEventStatusId.SecondQuarter:
      return { period: 2, overtime: 0 }
    case BasketballEventStatusId.ThirdQuarter:
      return { period: 3, overtime: 0 }
    case BasketballEventStatusId.FourthQuarter:
      return { period: 4, overtime: 0 }

    // regular time - halves
    case BasketballEventStatusId.FirstHalf:
      return { period: 1, overtime: 0 }
    case BasketballEventStatusId.SecondHalf:
      return { period: 2, overtime: 0 }

    // overtime
    case BasketballEventStatusId.FirstOvertime:
      return { period: numberOfPeriods, overtime: 1 }
    case BasketballEventStatusId.SecondOvertime:
      return { period: numberOfPeriods, overtime: 2 }
    case BasketballEventStatusId.ThirdOvertime:
      return { period: numberOfPeriods, overtime: 3 }
    case BasketballEventStatusId.FourthOvertime:
      return { period: numberOfPeriods, overtime: 4 }
    case BasketballEventStatusId.FifthOvertime:
      return { period: numberOfPeriods, overtime: 5 }
    default:
      return null
  }
}

const getIncidentDuration: GetIncidentDuration = (
  incidentId,
  eventStatusId,
  numberOfPeriods,
) => {
  // BreakAfter is "special" incidentId - it always ends current period, based on event status
  if (incidentId === BasketballIncidentId.BreakAfter) {
    return getEventStatusDuration(eventStatusId, numberOfPeriods)
  }

  const duration = getIncidentIdDuration(incidentId, numberOfPeriods)

  return duration ? getLiveDuration(duration) : null
}

export const eventDurationConfig: EventDurationConfig = {
  getEventStatusDuration,
  getIncidentDuration,
}
